import _cloneDeep from 'lodash/cloneDeep'
import _isEqual from 'lodash/isEqual'
import { eventBus } from 'frontend/communications/eventBus'
import { getActionsByPeopleStats,
  getActionsStats,
  getActionsTeamsStats } from 'frontend/communications/stats'

const stateObj = {
  actionsStats: null,
  actionsCollectedStats: null,
  actionsTeamsStats: null,
  actionsPeopleStats: null,
  actionsCachedFilters: null,
  actionsStatsCache: null,
}

const getters = {
  actionsStats (state) {
    return state.actionsStats
  },
  actionsCollectedStats (state) {
    return state.actionsCollectedStats
  },
  actionsTeamsStats (state) {
    return state.actionsTeamsStats
  },
  actionsPeopleStats (state) {
    return state.actionsPeopleStats
  },
  getActionsStats: state =>  filters => {
    if (state.actionsStatsCache && _isEqual(filters, state.actionsCachedFilters)) {
      return state.actionsStatsCache
    }
    state.actionsCachedFilters = _cloneDeep(filters)
    state.actionsStatsCache = getActionsStats(filters)
    return state.actionsStatsCache
  },
}

const mutations = {
  setActionsStats (state, actionsStats) {
    state.actionsStats = actionsStats
  },
  setActionsCollectedStats (state, actionsCollectedStats) {
    state.actionsCollectedStats = actionsCollectedStats
  },
  setActionsTeamsStats (state, actionsTeamsStats) {
    state.actionsTeamsStats = actionsTeamsStats
  },
  setActionsPeopleStats (state, actionsPeopleStats) {
    state.actionsPeopleStats = actionsPeopleStats
  },
}

const actions = {
  fetchActionsTeamsStats ({ commit }, payload) {
    eventBus.fetchingActionsStats(true)
    getActionsTeamsStats(payload).then(data => {
      commit('setActionsTeamsStats', data)
      eventBus.fetchingActionsStats(false)
    })
  },
  fetchActionsPeopleStats ({ commit }, payload) {
    return new Promise((resolve) => {
      getActionsByPeopleStats(payload).then(data => {
        commit('setActionsPeopleStats', data)
        resolve(data)
      })
    })
  },
}

export default {
  state: stateObj,
  getters,
  mutations,
  actions,
}
